import { render, staticRenderFns } from "./ListPanels.vue?vue&type=template&id=58316566&"
import script from "./ListPanels.vue?vue&type=script&lang=js&"
export * from "./ListPanels.vue?vue&type=script&lang=js&"
import style0 from "./ListPanels.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
installComponents(component, {VExpansionPanels})
